import { queryOptions, useQuery } from '@tanstack/react-query';

import { SecurityInsightsImagePackagesRequest } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

type Props = {
  tagId: string;
  enabled?: boolean;
  exceptionFilter?: SecurityInsightsImagePackagesRequest['exceptionFilter'];
};

const SECURITY_IMAGE_PACKAGES_QUERY_KEY = 'security-image-packages';

export const getImagePackagesQueryKey = (params?: {
  tagId: string;
  exceptionFilter: string;
}) =>
  params
    ? ([
        SECURITY_IMAGE_PACKAGES_QUERY_KEY,
        params.tagId,
        params.exceptionFilter,
      ] as const)
    : ([SECURITY_IMAGE_PACKAGES_QUERY_KEY] as const);

const getImagePackagesQueryOptions = ({
  tagId,
  exceptionFilter = 'all',
  enabled = true,
}: Props) =>
  queryOptions({
    queryKey: getImagePackagesQueryKey({
      tagId,
      exceptionFilter,
    }),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getImagePackages({
        tagId,
        exceptionFilter: exceptionFilter,
      });
      return data.items || null;
    },
    enabled,
  });

export const useImagePackagesQuery = ({
  tagId,
  exceptionFilter = 'all',
  enabled = true,
}: Props) => {
  const {
    isLoading,
    data: packages,
    error,
    refetch,
  } = useQuery(
    getImagePackagesQueryOptions({ tagId, exceptionFilter, enabled })
  );

  return {
    isLoading,
    packages: packages || undefined,
    error,
    refetch,
  };
};
